import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';

const SMALL_WIDTH_BREAKPOINT = 720;

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit {
  public isScreenSmall: boolean;
  currentUser: User;
  name: string;
  canViewCustomers = false;

  constructor(
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
  private permissionsService: NgxPermissionsService) { }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUser;

    this.breakpointObserver
      .observe([`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`])
      .subscribe((state: BreakpointState) => {
        this.isScreenSmall = state.matches;
        this.name = this.currentUser.name;
this.permissionsService.permissions$.subscribe(permissions => {
    console.log('Permissions:', permissions);
      const allowed = [
        'analyst', 'user', 'visu', 'visupartial', 'commercial', 'bpo'
      ];
      this.canViewCustomers = allowed.some(role => permissions[role]);
    });
        if (state.matches) {
          this.name = this.currentUser.username?.split('@')[0];
        }
      });
  }

  logout() {
    this.authService.logout().subscribe(data => { }, err => {
      throw Error(err);
    });
  }
}
